module.exports = __webpack_public_path__ + "img/icon-white-18.708fbb00.svg";